import { useDebouncedValue } from '@mantine/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import { useSpanCountForFilterQuery } from '@/features/statisticsSlice';
import { type FilterState } from '@/features/filterSlice';
import { generateBase64FilterQuery } from '@/features/filterHelpers';

interface UseDebouncedSpanCountProps {
  filterState?: FilterState | null;
  projectId?: string | null;
  debounceMs?: number;
}

export function useDebouncedSpanCount({
  filterState,
  projectId,
  debounceMs = 120,
}: UseDebouncedSpanCountProps) {
  // Debounce the filter state changes
  const [debouncedFilterState] = useDebouncedValue(filterState, debounceMs);

  // Generate query string for the debounced filter state
  const debouncedFilterQuery = debouncedFilterState
    ? generateBase64FilterQuery(debouncedFilterState)
    : null;

  // Query span count with debounced filter state
  return useSpanCountForFilterQuery(
    debouncedFilterQuery
      ? { filter: debouncedFilterQuery, listId: projectId ?? undefined }
      : skipToken
  );
}
